/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Crm_Document_InvalidInputs */

const en_error_crm_document_invalid = /** @type {(inputs: Error_Crm_Document_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These pages cannot be saved: a page names a brand the campaign does not invite.`)
};

/**
* | output |
* | --- |
* | "These pages cannot be saved: a page names a brand the campaign does not invite." |
*
* @param {Error_Crm_Document_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_crm_document_invalid = /** @type {((inputs?: Error_Crm_Document_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Crm_Document_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_crm_document_invalid(inputs)
});